import styled from 'styled-components';
import { BodyBoldL, CaptionRegularM, HeadingExtraBoldS } from '../../../styles/globals';
import { ITheme, IThemeProvider } from '../../../styles/theme';

export const TileCont = styled.div`
  display: flex;
  min-height: 64px;
  box-sizing: border-box;
  position: relative;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: 8px;
    margin: 0 0 ${theme.layout.spacing.mili} 0;
  `};
`;

export const TileBody = styled.div`
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;

  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy} 0 ${theme.layout.spacing.mili};
`};
`;

export const TileColumn = styled.div`
  position: relative;
  display: flex;
  width: calc(100% / 3);
  margin: 0 16px 0 0;
`;

interface ITileSide {
  theme: ITheme;
  isTotalsTabActive: boolean;
}

export const TileSide = styled.div<ITileSide>`
  position: relative;
  display: flex;
  align-items: center;

  ${({ theme, isTotalsTabActive }: ITileSide) => `
    flex: ${isTotalsTabActive ? '4' : '1'};
    padding: 0 ${theme.layout.spacing.decy} 0 0;
  `}
`;

export const ExpandContainer = styled.div`
  cursor: pointer;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 7.5px;
    height: 14.92px;
  }

  ${({ theme }: IThemeProvider) => `
    background: ${theme.colors.neutral.primary[0]};
    margin: 0 32px 0 0;

    &:hover {
      background: ${theme.colors.secondary[10]};
    }
    &:active {
      background: ${theme.colors.secondary[30]};
    }
  `};
`;

export const TileTitle = styled(HeadingExtraBoldS)`
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;

  //@media (min-width: 1360px) {
  //  width: 418px;
  //}

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
    margin: 0 ${theme.layout.spacing.deka} 0 0;
  `};
`;

export const ScoreResult = styled(BodyBoldL)`
  min-width: 115px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 22px;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `};
`;

interface IChartCont {
  isTotalsTabActive: boolean;
}

export const ChartCont = styled.div<IChartCont>`
  ${({ isTotalsTabActive }: IChartCont) => `
    flex: ${isTotalsTabActive ? '5' : '2.5'};
  `}
`;

export const AccordionBody = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const AccordionTableDesc = styled(CaptionRegularM)`
  box-sizing: border-box;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mili} 0;
    color: ${theme.colors.neutral.primary[80]};
    padding: 0 30px 0 96px;
  `};
`;
